document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.querySelector('.size-guide-trigger');
  const drawer = document.querySelector('.size-guide-drawer');
  const overlay = document.querySelector('.size-guide-overlay');
  const close = document.querySelector('.size-guide-close');

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
  }

  trigger?.addEventListener('click', openDrawer);
  close?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);
});